export default __webpack_public_path__ + "static/media/image_banner.fa68480a.png";